export const AUTHENTICATION_UNKNOW = 'authentication_unknow';
export const UNAUTHENTICATED = 'unauthenticated';
export const AUTHENTICATION_FAILED = 'authentication_failed';
export const AUTHENTICATION_SUCESS = 'authentication_success';
export const AUTHENTICATION_INPROGRESS = 'authentication_inprogress';
export const AUTHENTICATION_PENDING = 'authentication_pending';

export const AUTHENTICATION_RESET_PASSWORD_EMAIL_SENT =
  'authentication_reset_password_email_sent';
